import EnvironmentsIcon from "@mui/icons-material/Public";
import ContractIcon from "@mui/icons-material/Description";
import UsersIcon from "@mui/icons-material/PermIdentity";
import GavelIcon from "@mui/icons-material/Gavel";
import SitesIcon from "@mui/icons-material/WebAsset";
import { ICustomer } from "@river/interfaces";
import { ISidebarContent } from "../sidebar";

export const getCustomerSidebarContent = (
  customer: ICustomer
): ISidebarContent => ({
  parent: { primary: customer.description, to: "/customers" },
  items: [
    {
      icon: ContractIcon,
      primary: "Contract",
      to: `/customers/${customer._id}/contract`,
      items: [
        {
          primary: "Details",
          to: `/customers/${customer._id}/contract/details`,
        },
        {
          primary: "Notes",
          to: `/customers/${customer._id}/contract/notes`,
        },
        {
          primary: "Attachments",
          to: `/customers/${customer._id}/contract/attachments`,
        },
      ],
    },
    {
      icon: SitesIcon,
      primary: "Sites",
      to: `/customers/${customer._id}/sites`,
    },
    {
      icon: GavelIcon,
      primary: "Licenses",
      to: `/customers/${customer._id}/licenses`,
    },
    {
      icon: EnvironmentsIcon,
      primary: "Environments",
      to: `/customers/${customer._id}/environments`,
    },
    {
      icon: UsersIcon,
      primary: "Users",
      to: `/customers/${customer._id}/users`,
    },
  ],
});
